import { RouteSearchTaskStatus } from './types';

/**
 * Дефолтный статус задания на поиск маршрута
 */
export class DefaultRouteSearchTaskStatus implements RouteSearchTaskStatus {
  public typeSearch: 'SEARCH_NOT_COMPLETE_ROUTES' | 'SEARCH_COMPLETE_ROUTES' =
    'SEARCH_COMPLETE_ROUTES';
  public isSearchStepsComplete: boolean = false;
  public baseGraphBuildIsDone: boolean = false;
  public buildRoutesIsDone: boolean = false;
  public groupRoutesIsDone: boolean = false;
  public calculateGroupsIsDone: boolean = false;
}
